import { useForm, UseFormReturn } from "react-hook-form";
import RecurringBookingFormInterface, {
  RecurringBookingFormConfirm,
} from "../../../services/recurringBookingInterfaces";
import dayjs from "dayjs";

export const useFormRecurringBooking =
  (): UseFormReturn<RecurringBookingFormInterface> => {
    return useForm<RecurringBookingFormInterface>({
      defaultValues: {
        recurringBooking: {
          dataInizioRicerca: dayjs().add(1, "day").format("YYYY-MM-DD"),
          giorniAbilitati: {
            lunedi: true,
            martedi: true,
            mercoledi: true,
            giovedi: true,
            venerdi: true,
            sabato: true,
            domenica: false,
          },
        },
      },
      mode: "onSubmit",
    });
  };

export const useFormRecurringBookingConclusion =
  (): UseFormReturn<RecurringBookingFormConfirm> => {
    return useForm<RecurringBookingFormConfirm>({
      defaultValues: {
        keyStatus: "11",
        prestazioni: [],
      },
      mode: "onSubmit",
    });
  };
